import { E as ErrorBoundary, _ as __variableDynamicImportRuntimeHelper } from "./ErrorBoundary.js";
import { jsx } from "react/jsx-runtime";
import { useMemo, Suspense, lazy } from "react";
import { useIsServerSide } from "./hooks/useIsServerSide.js";
import { I as Illustration } from "./Illustration.js";
import { g as getIllustration } from "./utils.js";
import { IllustrationSizeList } from "./components/Illustrations/IllustrationNames.js";
const lazyLoadIllustration = (illustrationName, size) => {
  const sizes = IllustrationSizeList[illustrationName];
  const illustrationFileName = getIllustration({ size, ...sizes });
  return lazy(() => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "../Illustrations/Doctor.tsx": () => import("./components/Illustrations/Doctor.js"), "../Illustrations/DoctorMedium.tsx": () => import("./components/Illustrations/DoctorMedium.js"), "../Illustrations/DoctorSmall.tsx": () => import("./components/Illustrations/DoctorSmall.js"), "../Illustrations/FacialRecognitionFingerprint.tsx": () => import("./components/Illustrations/FacialRecognitionFingerprint.js"), "../Illustrations/FacialRecognitionFingerprintMedium.tsx": () => import("./components/Illustrations/FacialRecognitionFingerprintMedium.js"), "../Illustrations/HealthcarePersonnel.tsx": () => import("./components/Illustrations/HealthcarePersonnel.js"), "../Illustrations/HealthcarePersonnelMedium.tsx": () => import("./components/Illustrations/HealthcarePersonnelMedium.js"), "../Illustrations/HealthcarePersonnelSmall.tsx": () => import("./components/Illustrations/HealthcarePersonnelSmall.js"), "../Illustrations/ReadLetters.tsx": () => import("./components/Illustrations/ReadLetters.js"), "../Illustrations/ReadLettersMedium.tsx": () => import("./components/Illustrations/ReadLettersMedium.js"), "../Illustrations/Support2.tsx": () => import("./components/Illustrations/Support2.js"), "../Illustrations/Support2Medium.tsx": () => import("./components/Illustrations/Support2Medium.js") }), `../Illustrations/${illustrationFileName}.tsx`, 3));
};
const LazyIllustration = ({ illustrationName, size = 512, ...rest }) => {
  const illustration = useMemo(() => lazyLoadIllustration(illustrationName, size), [illustrationName, size]);
  const isServerSide = useIsServerSide();
  if (isServerSide) {
    return null;
  }
  const fallback = /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "fallback",
      role: "presentation",
      focusable: false,
      "aria-hidden": true,
      viewBox: "0 0 512 512",
      style: { minWidth: size, minHeight: size },
      width: size,
      height: size
    }
  );
  return /* @__PURE__ */ jsx(ErrorBoundary, { fallback, reset: illustrationName, children: /* @__PURE__ */ jsx(Suspense, { fallback, children: /* @__PURE__ */ jsx(Illustration, { illustration, size, ...rest }) }) });
};
export {
  LazyIllustration as L,
  lazyLoadIllustration as l
};
//# sourceMappingURL=LazyIllustration.js.map
